var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.523,
    height: 24.001,
    viewBox: "0 0 23.523 24.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "google_white",
    d: "M73.491,55.75a13.671,13.671,0,0,1,.232,2.52C73.724,65.125,69.134,70,62.2,70a12,12,0,0,1,0-24,11.52,11.52,0,0,1,8.025,3.127L66.846,52.51V52.5A6.571,6.571,0,0,0,62.2,50.687a7.309,7.309,0,1,0,0,14.619c3.593,0,6.037-2.056,6.541-4.876H62.2V55.75Z",
    transform: "translate(-50.2 -45.999)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleWhite);
export default __webpack_public_path__ + "static/media/google_white.0d7cd5eb6b5a0b6ce8685dc8a04e6cab.svg";
export { ForwardRef as ReactComponent };